module.exports = __webpack_public_path__ + "static/media/Driver_core.b5c21a4c.png";